/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:d4de0731-8a47-43e7-a78d-5d07c0e31e0e",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_CF2hmZd5R",
    "aws_user_pools_web_client_id": "41vobnsc1d5811mjbo70ileo44",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "acesemployee144314-dev",
    "aws_user_files_s3_bucket_region": "ap-southeast-2",
    "aws_dynamodb_all_tables_region": "ap-southeast-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "PoliciesAcknowledgement-dev",
            "region": "ap-southeast-2"
        }
    ],
    "aws_content_delivery_bucket": "aces-employee-portal-dev-dev",
    "aws_content_delivery_bucket_region": "ap-southeast-2",
    "aws_content_delivery_url": "https://d3r2vrr7ntxsq7.cloudfront.net",
    "aws_cloud_logic_custom": [
        {
            "name": "EmployeePortal",
            "endpoint": "https://k12zy2ynsi.execute-api.ap-southeast-2.amazonaws.com/dev",
            "region": "ap-southeast-2"
        }
    ]
};


export default awsmobile;
